import { render } from "./EstadoDM.vue?vue&type=template&id=57a1ed61"
import script from "./EstadoDM.vue?vue&type=script&lang=js"
export * from "./EstadoDM.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__